import React, { useEffect, useState } from 'react';
import {
    Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox,
} from '@mui/material';
import axios from 'axios';
import { useParams } from 'react-router-dom';


const StockClothUsed = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const { Id } = useParams();
    const [stkCloths, setStkCloths] = useState([]);
    const [clothNm, setClothNm] = useState('');
    const [totMtr, setTotMtr] = useState(0);
    useEffect(() => {
        fetchStkCloths(Id);
    }, [Id]);

    const fetchStkCloths = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getClothGivenUsedList&clothId=${id}`);
            const res = response?.data;
            console.log(res);
            const clothnm = res?.usedcloths[0]?.clothNm;
            setClothNm(clothnm);
            setStkCloths(res?.usedcloths);
            const totmtr = res?.usedcloths?.reduce((acc, sum) => acc + parseFloat(sum.gMtr), 0);
            setTotMtr(totmtr);
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };


    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };
    return (
        <>
            <div style={{ margin: '3%' }}>

                <Grid container spacing={2}>
                    <h2>Stock Used Mtr.</h2>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>
                            <h3>Cloth : {clothNm}</h3>

                            {Array.isArray(stkCloths) && stkCloths?.length > 0 &&
                                <>
                                    <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                        <Table>
                                            <TableHead>
                                                <TableRow className='tbl-row'>

                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Sr.No.</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Bale No.</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Bale Mtr.</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Given Mtr.</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {stkCloths.length > 0 ? (
                                                    stkCloths.map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{index + 1}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{item.baleNo}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{item.baleMtr}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{item.gMtr}</TableCell>
                                                        </TableRow>
                                                    ))
                                                ) : null}

                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'> </TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'> </TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px', fontWeight: 'bold' }} align='center'>Total Mtr.</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px', fontWeight: 'bold' }} align='center'>{totMtr}</TableCell>

                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                </>
                            }
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default StockClothUsed;
